/* eslint-disable max-len */
import React, { useContext, useState } from 'react';
import AnimatedModel from '../../../../../components/Animation/AnimatedModel';
import ConfirmationPrompt from '../../../../../components/ConfirmationPrompt';
import GlobalContext from '../../../../../components/Context/GloablContext';
import { dataService } from '../../../../../services/data.services';
import { useNavigate, useParams } from 'react-router-dom';
import AnimatedButton from '../../../../../components/Animation/AnimatedButton';
import DescriptionModal from '../../../../../components/DescriptionModal';
import FromatDateString from '../../../../../CommonMethods/FromatDateString';

const TableBody = ({tableData, indexNum, getBranch, branchName, selectedIndex,email, setSelectedIndex, selectedRef, lastIndex,searchParams, setSearchParams, List }) => {
    /**
     * This function sets the confirmation state to activate or deactivate an item in a table.
     */
    const navigate = useNavigate()
    const {setToastErrorMessage, setToastmessage, isInactiveBranch} = useContext(GlobalContext);
    const [activateButtonLoading, setActivateButtonLoading] = useState(false)
    const [activateOpen, setActivateOpen] = useState(false);
    const [descriptionModal,setDescriptionModal] = useState(false);

    /**
     * The function `handleActivateOpen` sets the state variable `activateOpen` to `true`.
     */
    const handleActivateOpen = () => {
        setActivateOpen(true)
    }

    /**
     * The function `handleOnCLickActivate` is an asynchronous function that updates the status of a
     * fee structure and displays a toast message accordingly.
     */
    const handleOnCLickActivate = async () => {
        setActivateButtonLoading(true);
        try {
            let body = { }
            body = {
                "status": !tableData.status,
            }
            let endpoint= `fee-structures/${tableData._id}`
            const response = await dataService.PatchAPI(body,endpoint);
            handleConformationClick();
            getBranch()
            setActivateButtonLoading(false);
            setToastmessage(`Fee structure ${!tableData.status ? 'activated' : 'deactivated'} successfully`);

        } catch (error) {
            handleConformationClick();
            setActivateButtonLoading(false);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            console.error(error);
        }    }

    /**
     * The function handleConformationClick sets the state variable activateOpen to false.
     */
    const handleConformationClick = () => {
        setActivateOpen(false)
    }

    /**
     * The function `handelActionButton` sets the selected index to the provided index number.
     */
    const handelActionButton = async(indexNum) =>{
        setSelectedIndex(indexNum)
    }
    return (
        <>
            <>
                <tr class={` cursor-pointer ${tableData.status?'':'inactive'}`} title={`View Fee Structure`} 
                    onClick={(e)=>{
                        if (e.target.classList.contains('prevent-click')) {
                            return;
                        } else {
                            navigate(`/fee-management/fee-structure/view-fee-structure/${tableData._id}?${searchParams.toString()}`)
                        }
                    }}
                >
                    <td class="text-start">
                        {tableData?.academic_year?.name}
                    </td>                             
                    <td class="text-start">
                        {tableData?.class_name}
                    </td>
                    <td class="text-end">
                        {parseFloat(tableData?.cumulative_amount).toFixed(2)}
                    </td>
                    <td class="text-start">
                        {FromatDateString(tableData?.created_at)}
                    </td>
                    <td class="text-start">
                        {tableData?.created_by}
                    </td>
                    <td class="table-cell">
                        <div className='flex justify-center'>
                            <div className={`rounded ${tableData.status ? 'bg-[#C5FFD5]' : 'bg-[#B3BBC1]'} flex items-center justify-center py-1 px-2.5 w-fit`}>
                                <img loading="lazy" decoding="async" src={tableData.status ? "/images/successDot.svg" : "/images/inactive-Dot.svg" } alt="icon"/>
                                <span className="text-f7 font-normal text-[#031624] pl-1">{tableData.status ? 'Active' : 'Inactive'}</span>
                            </div>
                        </div>
                    </td>
                    <td class="text-start prevent-click">
                        <div className="relative flex items-center justify-center prevent-click" data-te-dropdown-ref>
                            <button type='button' className={`list-more-btn prevent-click`} href="#"
                                id={tableData.email_address}
                                // disabled={(userCognitoEmail === tableData.email_address) ? true : false}
                                onClick={() =>handelActionButton(indexNum) }
                                data-te-dropdown-toggle-ref
                                aria-expanded="false"
                                data-te-ripple-init
                                // disabled={() => handelActionButton()}
                                data-te-ripple-color="light">
                                <img loading="lazy" decoding="async" src="/images/listAction.svg" alt="icon" class="prevent-click"/>
                            </button>
                            {selectedIndex === indexNum &&  <ul ref={selectedRef} className={`${(indexNum+1 === 10 || indexNum+2 === 10) ? (tableData?.status?"top3":"top1") : ''} list-more-optns-div [&[data-te-dropdown-show]]:block`}
                                aria-labelledby="dropdownMenuButton2" data-te-dropdown-menu-ref>
                                <li>
                                    <AnimatedButton
                                        handleClick={() => { }}
                                        buttonName={"View Details"}
                                        link={`/fee-management/fee-structure/view-fee-structure/${tableData._id}?${searchParams.toString()}`}
                                        className="list-more-optns prevent-click" />
                                </li>                                   
                                {!isInactiveBranch && <>
                                    {tableData.status && <>
                                        
                                        <li>
                                            <AnimatedButton
                                                handleClick={() => { }}
                                                // handleClick={handleEditClick}
                                                buttonName={"Edit Fee Structure"}
                                                link={`/fee-management/fee-structure/update-fee-structure/${tableData._id}?${searchParams.toString()}`}
                                                className="list-more-optns prevent-click" />
                                        </li></>
                                    }
                                    <li>
                                        <AnimatedButton
                                            handleClick={(e) => handleActivateOpen(e)}
                                            buttonName={!tableData.status ? "Activate" : "Deactivate"}
                                            className="list-more-optns prevent-click" />
                                    </li>
                                </>      
                                }                                                             
                            </ul>}
                        </div>
                    </td>
                </tr>
            </>
            {activateOpen && 
            <AnimatedModel
                Children={
                    <ConfirmationPrompt
                        handleOnCLickActivate={handleOnCLickActivate}
                        handleClose={handleConformationClick}
                        tittle= {`${!tableData.status ? 'Activate' : 'Deactivate'} Fee Structure`}
                        // additionalMessage={'Once the class is activated, it cannot be deactivated.'}
                        message = {`Are you sure you want to ${!tableData.status ? 'activate' : 'deactivate'} the Fee Structure for Academic Year '${tableData?.academic_year?.name}' and Class '${tableData?.class_name}' ?`}
                        buttonName = {`${!tableData.status ? 'Activate' : 'Deactivate'}`}
                        loadingActivation={activateButtonLoading}
                    />
                }
            />  
            }
            {descriptionModal && 
                <DescriptionModal 
                    descriptionModal={descriptionModal}
                    setDescriptionModal={setDescriptionModal}
                    description={tableData.description}
                />
            }
        </>
    );
}

export default TableBody;
